import { Extension } from "@tiptap/core";
import { Suggestion, SuggestionOptions } from "@tiptap/suggestion";

const Commands = Extension.create<{
  suggestion: Pick<
    SuggestionOptions,
    "items" | "render" | "char" | "command" | "startOfLine"
  >;
}>({
  name: "commands_2",

  addOptions() {
    return {
      suggestion: {
        char: "/",
        startOfLine: true,
        command: ({ editor, range, props }) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          props.command({ editor, range });
        },
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});

export default Commands;
